module.exports = __webpack_public_path__ + "img/Upload.7f05f923.png";